import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  marketMargins: null,
  tennisMarketMargins: null,
};

export const marketMarginsSlice = createSlice({
  name: 'marketMargins',
  initialState,
  reducers: {
    aGetMarketMarginsSuccess: (state, action) => {
      state.marketMargins = action.payload.marketMargins;
    },
    aUpdateMarketMargins: (state, action) => {
      state.marketMargins = action.payload.marketMargins;
    },
    aGetTennisMarketMarginsSuccess: (state, action) => {
      state.tennisMarketMargins = action.payload.marketMargins;
    },
    aUpdateTennisMarketMargins: (state, action) => {
      state.tennisMarketMargins = action.payload.marketMargins;
    },
    aClearMarketMargins: (state) => {
      state.marketMargins = null;
    },
    aClearTennisMarketMargins: (state) => {
      state.tennisMarketMargins = null;
    },
  },
});

export const {
  aGetMarketMarginsSuccess,
  aUpdateMarketMargins,
  aGetTennisMarketMarginsSuccess,
  aUpdateTennisMarketMargins,
  aClearMarketMargins,
  aClearTennisMarketMargins,
} = marketMarginsSlice.actions;

export default marketMarginsSlice.reducer;
